import React from 'react';
import './App.css';
import Clients from './components/Clients';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Home from './components/Home';
import Careers from './components/Careers';
import Apply from './components/Apply';
import NavBar from './components/NavBar';
import NotFound from './components/NotFound';
import Employees from './components/Employees';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <Router>
      <>
        <NavBar />
        <Routes>
          <Route exact path="/" element={<Home />}/>
          <Route path="/clients" element={<Clients />}/>
          <Route path="/careers" element={<Careers />}/>
          <Route path="/employees" element={<Employees />}/>
          <Route path="/contact" element={<Contact />}/>
          <Route path="/apply" element={<Apply />}/>
          <Route path="*" element={<NotFound />}/>
        </Routes>
        <Footer />
      </>
    </Router>
  );
}

export default App;
